import { addBankAccount } from "api/affiliations/addBankAccount";
import Loading from "components/ui-components/loading";
import addNotification from "helpers/notify";
import { useHttp } from "hooks/useHttp";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TopNavbar from "../navbar";
import Sidebar from "../sidebar";
import {
  getCompanySettings,
  getCompanySettingsAdmin,
  putCompanySettings,
} from "api/companySettings/getCompanySettings";
import Loader from "components/Loader";
import DefaultImage from "assets/images/user.png";
import UploadIcon from "assets/images/icons/Featured icon.png";
import { extractImageFromZip } from "helpers/extractImageFromZip";
import { uploadFileToServer } from "components/uploadFile/uploadFile";
import moment from "moment";
import { eventTrack } from "helpers/ga4Helper";

export default function CompanySettings() {
  const userInfoRedux = useSelector((s) => s.user.userInfo);

  const [companyDetails, setCompanyDetails] = useState({
    companyName: "",
    companyAddress: "",
    companyPhoneNumber: "",
    companyOwner: "",
    companySize: "",
    companyIndustry: "",
    dateOfExpiration: "",
    // brand resolver fallback — when an entity has no brand_id of its
    // own, the AI processors fall back to this one. Null = "most recent
    // brand" heuristic in worker/services/brandContext.
    defaultBrand_id: "",
  });

  const [image, setImage] = useState("");
  const [URL, SET_URL] = useState("");

  const [logoUrl, setLogoUrl] = useState(null);
  const fileInputRef = useRef(null);

  const [brandsForPicker, setBrandsForPicker] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const { get } = await import("../../../api");
        const r = await get("/brands");
        setBrandsForPicker((r && r.data) || []);
      } catch (_) { /* picker stays empty if /brands fails */ }
    })();
  }, []);

  useEffect(() => {
    getCompanySettingsAPI();
  }, []);

  const [openEdit, setOpenEdit] = useState(false);

  const { loading: loadingPostSettings, request: updateSettingsAPI } = useHttp({
    requestCallback: (data) => putCompanySettings(data),
    onLoad: (res) => {
      addNotification("Success", "success");
      setOpenEdit(false);
    },
    onError: (res) => {
      addNotification(res?.err, "danger");
    },
  });

  const { loading: loadingGetSettings, request: getCompanySettingsAPI } =
    useHttp({
      requestCallback: (data) =>
        getCompanySettingsAdmin(userInfoRedux?.company),
      onLoad: (res) => {
        console.log(res);
        setCompanyDetails((prevData) => ({
          ...prevData,
          companyName: res?.companyName,
          companyAddress: res?.companyAddress,
          companyPhoneNumber: res?.companyPhoneNumber,
          companyOwner: res?.companyOwner,
          companySize: res?.companySize,
          companyIndustry: res?.companyIndustry,
          dateOfExpiration: res?.dateOfExpiration,
          defaultBrand_id: res?.defaultBrand_id || "",
        }));

        setLogoUrl(res?.companyLogo);
        // SET_URL(extractImageFromZip(res?.companyLogo));
        (async () => {
          const extractedImg = await extractImageFromZip(res?.companyLogo);
          SET_URL(extractedImg);
        })();
      },
      onError: (res) => {
        // addNotification(res?.err, "danger");
      },
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (image) {
      var fileUrl;
      fileUrl = await uploadFileToServer(image);
    }

    const payload = {
      ...companyDetails,
      companyLogo: image ? fileUrl : logoUrl,
      _id: userInfoRedux?.company,
    };

    // console.log(payload);
    updateSettingsAPI(payload);
    eventTrack(
      "Update-Company-Settings-Action",
      "Update-Company-Settings",
      userInfoRedux?.name,
      "+1",
      false,
      "+1"
    );
  };

  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setCompanyDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCancel = () => {
    setOpenEdit(false);
    getCompanySettingsAPI();
  };

  const handleSearch = () => {};

  const handleAvatarClick = () => {
    fileInputRef.current.click();
  };

  const handleProfileImg = async (e) => {
    const selectedImg = e.target.files[0];
    setImage(selectedImg);
  };

  return (
    <div className="personal-area">
      {loadingGetSettings && <Loader />}
      <TopNavbar handleSearch={handleSearch} />

      <div className="content-bg p-2">
        <div className="container d-flex mt-1">
          <Sidebar />

          <div className="profile-content px-0 pt-0">
            <div className="w-100 py-4 px-4 profile-div position-relative">
              <p className="font-weight-bold text-black mb-1 h5">
                Company settings
              </p>
              <p>Update your Company details here.</p>
              <button
                className="editBankAccount"
                onClick={() => setOpenEdit(true)}
              >
                <i className="fa fa-pen"></i>
              </button>
              <hr />
              <form onSubmit={handleSubmit} className="w-75">
                <div className="">
                  <img
                    src={image ? window.URL.createObjectURL(image) : URL}
                    // src={URL}
                    className="d-block mt-4"
                    style={{ width: 100, height: 100, borderRadius: 100 }}
                    // onError={(e) => (e.target.src = DefaultImage)}
                  />

                  <div
                    className={`profile-upload-box ${
                      openEdit ? "cursor-pointer" : "cursor-disabled"
                    }`}
                    onClick={openEdit && handleAvatarClick}
                  >
                    <img src={UploadIcon} />
                    <p className="font-weight-bold text-bid">
                      Click to upload company logo{" "}
                    </p>
                    <p className="font-weight-bold">
                      SVG, PNG, JPG or GIF (max. 800x400px)
                    </p>

                    <input
                      ref={fileInputRef}
                      onChange={handleProfileImg}
                      type="file"
                      id="profilePicture"
                      name="profilePicture"
                      accept="image/*"
                      style={{ display: "none" }}
                      readOnly={!openEdit}
                    />
                  </div>
                </div>
                <div className="my-2">
                  <label className="labels font-weight-bold text-bid">
                    Company Name
                  </label>
                  <input
                    name="companyName"
                    onChange={handleOnchange}
                    value={companyDetails?.companyName || ""}
                    type="text"
                    className="form-control"
                    required
                    readOnly={!openEdit}
                  />
                </div>

                <div className="my-2">
                  <label className="labels font-weight-bold text-bid">
                    Company Address
                  </label>
                  <input
                    name="companyAddress"
                    onChange={handleOnchange}
                    value={companyDetails?.companyAddress || ""}
                    type="text"
                    className="form-control"
                    required
                    readOnly={!openEdit}
                  />
                </div>

                <div className="d-flex align-items-center justify-content-between w-100 gap-3 my-2">
                  <div className="w-50">
                    <label className="labels font-weight-bold text-bid">
                      Company Phone Number
                    </label>
                    <input
                      name="companyPhoneNumber"
                      onChange={handleOnchange}
                      value={companyDetails?.companyPhoneNumber || ""}
                      type="text"
                      className="form-control"
                      required
                      readOnly={!openEdit}
                    />
                  </div>

                  <div className="w-50">
                    <label className="labels font-weight-bold text-bid">
                      Company Owner
                    </label>
                    <input
                      name="companyOwner"
                      onChange={handleOnchange}
                      value={companyDetails?.companyOwner || ""}
                      type="text"
                      className="form-control"
                      required
                      readOnly
                    />
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between w-100 gap-3 my-2">
                  <div className="w-50">
                    <label className="labels font-weight-bold text-bid">
                      Company Size
                    </label>
                    <input
                      name="companySize"
                      onChange={handleOnchange}
                      value={companyDetails?.companySize || ""}
                      type="text"
                      className="form-control"
                      readOnly={!openEdit}
                    />
                  </div>

                  <div className="w-50">
                    <label className="labels font-weight-bold text-bid">
                      Company Industry
                    </label>
                    <input
                      name="companyIndustry"
                      onChange={handleOnchange}
                      value={companyDetails?.companyIndustry || ""}
                      type="text"
                      className="form-control"
                      readOnly
                    />
                  </div>
                </div>

                <div className="w-100 my-2">
                  <label className="labels font-weight-bold text-bid">
                    Default Brand (AI voice fallback)
                  </label>
                  <select
                    name="defaultBrand_id"
                    onChange={handleOnchange}
                    value={companyDetails?.defaultBrand_id || ""}
                    className="form-control"
                    disabled={!openEdit}
                  >
                    <option value="">— most-recent brand (auto) —</option>
                    {brandsForPicker.map((b) => (
                      <option key={b._id} value={b._id}>{b.name}</option>
                    ))}
                  </select>
                  <small style={{ color: "#888", fontSize: 11 }}>
                    Used when an email/chat/SEO/CRM action runs against an
                    entity with no brand of its own.
                  </small>
                </div>

                <div className="w-100">
                  <label className="labels font-weight-bold text-bid">
                    Company Expiration Date
                  </label>
                  <input
                    name="dateOfExpiration"
                    onChange={handleOnchange}
                    value={
                      moment(companyDetails?.dateOfExpiration).format(
                        "DD/MM/YYYY"
                      ) || ""
                    }
                    type="text"
                    className="form-control"
                    readOnly
                  />
                </div>

                {loadingPostSettings && (
                  <Loading color="black" text="Updating..." />
                )}
                {openEdit && (
                  <div className="d-flex ml-auto w-100 mt-3">
                    <button
                      className="header-btn text-bid bg-white border-bid px-3"
                      type="button"
                      onClick={() => handleCancel()} // Uncomment or modify this if you have a cancel function
                    >
                      Cancel
                    </button>
                    <button
                      className="header-btn text-white bg-bid border-bid px-4"
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                )}
              </form>

              <hr />
              <ApiKeyPanel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Pure helpers behind the API-keys panel — toggling a value in a
// selection list and rendering a key's brand restriction. Exported via
// CompanySettings._test so they can be unit-tested in isolation.
const apiKeyHelpers = {
  // Add value if absent, remove it if present. Stringifies for stable
  // comparison (brand ids arrive as Objects/strings interchangeably).
  toggleInList(list, value) {
    const v = String(value);
    const arr = (list || []).map(String);
    return arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v];
  },
  // Human label for a key's brand allow-list: "All brands" when empty,
  // otherwise the brand names (falling back to a short id tail).
  brandLabel(brandIds, brandNameById) {
    if (!brandIds || !brandIds.length) return "All brands";
    return brandIds
      .map((id) => (brandNameById && brandNameById[String(id)]) || String(id).slice(-6))
      .join(", ");
  },
};

// ── API keys panel ──────────────────────────────────────────────────
// Lists company keys; supports creating + revoking. The plaintext
// secret only appears once at creation — modelled after how every
// other SaaS does it because the operator's other app needs to copy
// it into their config.
function ApiKeyPanel() {
  const [keys, setKeys] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [creating, setCreating] = React.useState(false);
  const [newLabel, setNewLabel] = React.useState('');
  const [justCreated, setJustCreated] = React.useState(null); // plaintext shown once
  const [error, setError] = React.useState(null);
  // Catalogue from GET /meta: every grantable scope + the company's brands.
  const [availableScopes, setAvailableScopes] = React.useState([]);
  const [availableBrands, setAvailableBrands] = React.useState([]);
  // Selections for the next key. Default to contacts:write (the legacy
  // default) and no brand restriction (all brands).
  const [selectedScopes, setSelectedScopes] = React.useState(['contacts:write']);
  const [selectedBrandIds, setSelectedBrandIds] = React.useState([]);

  const brandNameById = React.useMemo(() => {
    const m = {};
    availableBrands.forEach((b) => { m[String(b._id)] = b.name; });
    return m;
  }, [availableBrands]);

  const refresh = React.useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const { get } = await import("../../../api");
      const r = await get("/api/api-keys");
      setKeys((r && r.data) || []);
    } catch (e) { setError((e && e.message) || "Failed to load"); }
    finally { setLoading(false); }
  }, []);

  const loadMeta = React.useCallback(async () => {
    try {
      const { get } = await import("../../../api");
      const r = await get("/api/api-keys/meta");
      const d = (r && r.data) || {};
      setAvailableScopes(d.scopes || []);
      setAvailableBrands(d.brands || []);
    } catch (_) { /* meta is best-effort; create still works with defaults */ }
  }, []);

  React.useEffect(() => { refresh(); loadMeta(); }, [refresh, loadMeta]);

  const toggleScope = (value) => setSelectedScopes((prev) => apiKeyHelpers.toggleInList(prev, value));
  const toggleBrand = (id) => setSelectedBrandIds((prev) => apiKeyHelpers.toggleInList(prev, id));

  const create = async () => {
    setCreating(true); setError(null);
    try {
      const { post } = await import("../../../api");
      const r = await post("/api/api-keys", {
        label: newLabel || "integration",
        scopes: selectedScopes,
        brandIds: selectedBrandIds,
      }, false);
      const d = (r && r.data) || {};
      setJustCreated({
        label: newLabel || "integration",
        plaintext: d.plaintext,
        keyPrefix: d.keyPrefix,
        scopes: d.scopes || selectedScopes,
        brandIds: d.brandIds || selectedBrandIds,
      });
      setNewLabel("");
      setSelectedBrandIds([]);
      setSelectedScopes(['contacts:write']);
      refresh();
    } catch (e) { setError((e && e.message) || "Create failed"); }
    finally { setCreating(false); }
  };

  const revoke = async (id) => {
    if (!window.confirm("Revoke this key? Any integrations using it will break immediately.")) return;
    try {
      const { post } = await import("../../../api");
      await post(`/api/api-keys/${id}/revoke`, {}, false);
      refresh();
    } catch (e) { alert((e && e.message) || "Revoke failed"); }
  };

  const fmtDate = (v) => v ? new Date(v).toLocaleString() : "—";

  return (
    <div style={{ marginTop: 20 }}>
      <h6 style={{ fontSize: 14, color: "#15172b", fontWeight: 700, marginBottom: 4 }}>API keys</h6>
      <div style={{ fontSize: 12, color: "#888", marginBottom: 12 }}>
        Long-lived bearer tokens for your other apps to push contacts + lifecycle events into prigmar's CRM.
        Use as <code>Authorization: Bearer pk_...</code> on <code>POST /api/v1/contacts/upsert</code> and
        <code> POST /api/v1/contacts/event</code>.
      </div>

      {justCreated && (
        <div style={{ background: "#fff4cc", border: "1px solid #d97706", color: "#856404", padding: 12, borderRadius: 6, marginBottom: 12, fontSize: 12 }}>
          <strong>New key — copy it now.</strong> This is the only time you'll see the full value.
          <pre style={{ background: "#fff", padding: 8, borderRadius: 4, marginTop: 6, marginBottom: 6, userSelect: "all", wordBreak: "break-all" }}>
{justCreated.plaintext}
          </pre>
          <button
            type="button"
            className="header-btn text-bid bg-white border-bid"
            style={{ fontSize: 11, padding: "4px 12px" }}
            onClick={async () => {
              try { await navigator.clipboard.writeText(justCreated.plaintext); } catch (_) {}
            }}
          >Copy</button>
          <button
            type="button"
            className="header-btn text-bid bg-white border-bid"
            style={{ fontSize: 11, padding: "4px 12px", marginLeft: 6 }}
            onClick={() => setJustCreated(null)}
          >Done — I've copied it</button>
        </div>
      )}

      {error && <div className="alert alert-warning" style={{ fontSize: 13 }}>{error}</div>}

      <div style={{ background: "#fafbfc", border: "1px solid #eee", borderRadius: 6, padding: 12, marginBottom: 12 }}>
        <input
          type="text"
          value={newLabel}
          onChange={(e) => setNewLabel(e.target.value)}
          placeholder="Key label (e.g. internal-crm-sync)"
          className="form-control"
          style={{ width: "100%", fontSize: 13, marginBottom: 12 }}
        />

        {/* Scopes — what the key is allowed to do on /api/v1/* */}
        <div style={{ fontSize: 12, fontWeight: 700, color: "#15172b", marginBottom: 6 }}>Scopes</div>
        <div style={{ fontSize: 11, color: "#888", marginBottom: 8 }}>
          Pick what this key can do. A key with no scope selected defaults to write.
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 14 }}>
          {(availableScopes.length ? availableScopes : [
            { value: "contacts:write", label: "Write contacts", description: "Upsert contacts and fire lifecycle events (implies read)." },
          ]).map((s) => (
            <label key={s.value} style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 12, cursor: "pointer", margin: 0 }}>
              <input
                type="checkbox"
                checked={selectedScopes.includes(s.value)}
                onChange={() => toggleScope(s.value)}
                style={{ marginTop: 2 }}
              />
              <span>
                <code style={{ fontSize: 11 }}>{s.value}</code>
                <span style={{ color: "#666" }}> — {s.label}{s.description ? `: ${s.description}` : ""}</span>
              </span>
            </label>
          ))}
        </div>

        {/* Brands — restrict the key to a subset of the company's brands */}
        <div style={{ fontSize: 12, fontWeight: 700, color: "#15172b", marginBottom: 6 }}>Brands</div>
        <div style={{ fontSize: 11, color: "#888", marginBottom: 8 }}>
          Leave all unchecked to allow every brand. Selecting brands restricts the key so it only works for those brands' contacts.
        </div>
        {availableBrands.length === 0 ? (
          <div style={{ fontSize: 12, color: "#aaa", marginBottom: 12 }}>No brands found for this company.</div>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 16px", marginBottom: 12, maxHeight: 160, overflowY: "auto" }}>
            {availableBrands.map((b) => (
              <label key={b._id} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer", margin: 0 }}>
                <input
                  type="checkbox"
                  checked={selectedBrandIds.includes(String(b._id))}
                  onChange={() => toggleBrand(b._id)}
                />
                <span>{b.name}</span>
              </label>
            ))}
          </div>
        )}

        <button
          type="button"
          className="header-btn text-white bg-bid border-bid px-3"
          onClick={create}
          disabled={creating}
        >{creating ? "Creating…" : "+ New API key"}</button>
      </div>

      {loading && keys.length === 0 && <div style={{ fontSize: 12, color: "#888" }}>Loading…</div>}
      {!loading && keys.length === 0 && (
        <div style={{ fontSize: 12, color: "#888", padding: 12, background: "#fafbfc", borderRadius: 6 }}>
          No API keys yet. Create one above.
        </div>
      )}
      {keys.length > 0 && (
        <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #e5e5e5" }}>
              <th style={{ textAlign: "left", padding: 6, fontSize: 11, color: "#888" }}>Label</th>
              <th style={{ textAlign: "left", padding: 6, fontSize: 11, color: "#888" }}>Prefix</th>
              <th style={{ textAlign: "left", padding: 6, fontSize: 11, color: "#888" }}>Scopes</th>
              <th style={{ textAlign: "left", padding: 6, fontSize: 11, color: "#888" }}>Brands</th>
              <th style={{ textAlign: "left", padding: 6, fontSize: 11, color: "#888" }}>Last used</th>
              <th style={{ textAlign: "left", padding: 6, fontSize: 11, color: "#888" }}>From IP</th>
              <th style={{ textAlign: "left", padding: 6, fontSize: 11, color: "#888" }}>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {keys.map((k) => (
              <tr key={k._id} style={{ borderBottom: "1px solid #f4f4f4" }}>
                <td style={{ padding: 6 }}>{k.label || "—"}</td>
                <td style={{ padding: 6, fontFamily: "ui-monospace,SFMono-Regular,Menlo,monospace", fontSize: 11 }}>{k.keyPrefix}…</td>
                <td style={{ padding: 6, fontSize: 11 }}>
                  {(k.scopes && k.scopes.length)
                    ? k.scopes.map((s) => (
                        <span key={s} style={{ display: "inline-block", background: "#eef2ff", color: "#3730a3", padding: "1px 6px", borderRadius: 8, fontSize: 10, marginRight: 4, marginBottom: 2 }}>{s}</span>
                      ))
                    : <span style={{ color: "#aaa" }}>—</span>}
                </td>
                <td style={{ padding: 6, fontSize: 11, color: "#555" }}>
                  {(k.brandIds && k.brandIds.length)
                    ? apiKeyHelpers.brandLabel(k.brandIds, brandNameById)
                    : <span style={{ color: "#888" }}>All brands</span>}
                </td>
                <td style={{ padding: 6, fontSize: 11, color: "#888" }}>{fmtDate(k.lastUsedAt)}</td>
                <td style={{ padding: 6, fontSize: 11, color: "#888" }}>{k.lastUsedIp || "—"}</td>
                <td style={{ padding: 6 }}>
                  {k.revoked
                    ? <span style={{ background: "#fdecea", color: "#a71d2a", padding: "2px 8px", borderRadius: 10, fontSize: 11 }}>revoked</span>
                    : <span style={{ background: "#e7f5ec", color: "#1e6b3e", padding: "2px 8px", borderRadius: 10, fontSize: 11 }}>active</span>}
                </td>
                <td style={{ padding: 6, textAlign: "right" }}>
                  {!k.revoked && (
                    <button
                      type="button"
                      className="header-btn text-bid bg-white border-bid"
                      style={{ fontSize: 11, padding: "2px 10px" }}
                      onClick={() => revoke(k._id)}
                    >Revoke</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

// Expose pure helpers for unit tests (mirrors the project convention of
// attaching ._test to the default export — see CustomWorkers).
CompanySettings._test = apiKeyHelpers;
